import ArrowForward from '@mui/icons-material/ArrowForward';
import MenuIcon from '@mui/icons-material/Menu';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import WNButton from '../components/FormComponents/WNButton';
import { setIsSideDrawerOpen } from '../features/navigation/slices/navigationReducer';

const AboutPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleContinueDonate = () => {
    navigate('/donate');
  };

  return (
    <div className="about-page-wrapper">
      <MenuIcon
        className="hamburger-menu-icon"
        onClick={() => dispatch(setIsSideDrawerOpen(true))}
      />

      <div className="about-page">
        <div className="about-hero">
          <h2 className="about-tagline">
            The Internet is Broken. Let's Re-wild it, Together.
          </h2>
        </div>

        <div className="about-content">
          <p className="lead">
            It wasn't always like this. Artists used to post their entire
            portfolios on personal websites. People documented how they
            hand-sewed historically accurate 18th-century gowns. Bloggers broke
            down nutrition studies so you could figure out if the experts were
            full of shit. (Are eggs good or bad? Good luck with that now.)
          </p>

          <p>
            Then corporations broke it. Now it's SEO spam, AI slop, and
            influencers trying to waste your time.
          </p>

          <div className="about-callout">
            <p>The real Internet still exists. But it's buried.</p>
            <p>The WilderNet is your map to find it.</p>
          </div>

          <p>
            We're building a search engine for the independent web — built by
            humans, not algorithms. Every blog you add to the directory is
            another piece of the real internet we can uncover together.
          </p>

          <div className="action-section">
            <h3>How It Works:</h3>

            <div className="how-it-works-grid">
              <div className="feature-item">
                <h4>Explore</h4>
                <p>Hand-picked independent writing across tech, travel, DIY, culture, and more.</p>
              </div>

              <div className="feature-item">
                <h4>Search</h4>
                <p>Find blogs and articles buried under Google's spam — no AI slop, no ad farms.</p>
              </div>

              <Link to="/create-curated-list" className="action-card-link">
                <div className="action-card">
                  <h4>Create</h4>
                  <p>Build reading lists from the blogs and articles you love. Share your discoveries with others.</p>
                  <div className="action-card-arrow">
                    <ArrowForward fontSize="small" />
                  </div>
                </div>
              </Link>

              <Link to="/upload-blog" className="action-card-link">
                <div className="action-card">
                  <h4>Contribute</h4>
                  <p>Found a real blog worth reading? Submit it to the directory so others can find it too.</p>
                  <div className="action-card-arrow">
                    <ArrowForward fontSize="small" />
                  </div>
                </div>
              </Link>
            </div>
          </div>

          <div className="principle-box">
            <h3>To Stay Wild, We Stay Independent.</h3>
            <p>
              No ads. No tracking. No VC money telling us to optimize for
              engagement.
            </p>
            <p>
              Donations pay for servers and keep us accountable to readers, not
              investors.
            </p>

            <div className="principle-box-donation">
              <Link to="/donate" className="principle-box-donation-link">
                <WNButton
                  buttonText="Donate"
                  optionalClass="principle-box-donation-button"
                  onClick={handleContinueDonate}
                  isSecondary={false}
                />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;